import { useState, useEffect } from 'react';
import FacilityPanel from './Panel';
import FacilityViewPanel from './FacilityView/index';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from '../../../../../api/APIEndpoints';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
//Toast
import { ToastContainer, toast } from 'react-toastify';
import ToastMessage from '../../../../common/ToastMessage';
import 'react-toastify/dist/ReactToastify.css';
//import {TrashIcon} from '../../../../img/findcare/FindCareSVG';

const FacilityFilterPanel = ({
  label,
  //onSelectedBrokersCount,
  updateSelectedItemCount,
  //onSelectedBrokers,
  onSelectedItems,
  createUserFormData,
  handleValChange,
  isContinueClicked,
  nextStep,
  //onSetAllBrokers,
  onSelectAllItems,
  //selectedBrokerData,
  selectedItemsData,
  selectedFacilityDoctors,
  selectedFacilitiesList,
  editAffiliatedRecords,
  getSelectedDoctor = null,
  allowDoctorSelection = true,
}) => {
  const [selectedFacilities, setSelectedFacilities] = useState(
    selectedItemsData && selectedItemsData.length > 0
      ? selectedItemsData
      : createUserFormData?.providerDetails?.facilities,
  );
  const [deleteItemId, setDeleteItemId] = useState('');
  const [selectedDoctor, setSelectedDoctor] = useState(
    selectedFacilityDoctors && selectedFacilityDoctors.length > 0
      ? selectedFacilityDoctors
      : createUserFormData?.providerDetails?.selectedDoctorsByFacility || null,
  );
  const [
    selectedAllFacilitiesOfSameTaxId,
    setSelectedAllFacilitiesOfSameTaxId,
  ] = useState([]);
  const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  let FacilityListResponse = null;
  let FacilityListDataResponse = null;

  const handleuncheckedItems = (tempSelectedItems, unCheckedItem) => {
    const tempSelectedFacilities = [];
    const tempObjDoctor = { ...selectedDoctor };
    console.log('tempSelectedItems inside ==========', tempSelectedItems);
    console.log('unCheckedItem ==========', unCheckedItem);
    unCheckedItem.map((firstObj) => {
      tempSelectedItems.map((compareObj, i) => {
        if (firstObj === compareObj.FacilityOID) {
          tempSelectedFacilities.push(compareObj);
          tempSelectedItems.splice(i, 1);
        }
        return;
      });
      return;
    });
    console.log('tempSelectedItems inside 1111 ==========', tempSelectedItems);
    setSelectedFacilities(tempSelectedItems);

    unCheckedItem.map((facilityOid) => {
      if (Object.prototype.hasOwnProperty.call(selectedDoctor, facilityOid)) {
        //const tempObjDoctor = { ...selectedDoctor };
        delete tempObjDoctor[facilityOid];
        //setSelectedDoctor( tempObjDoctor );
      }
      return;
    });
    setSelectedDoctor(tempObjDoctor);

    const tempObj = selectedAllFacilitiesOfSameTaxId;
    tempSelectedFacilities.map((ele) => {
      const index = tempObj.indexOf(ele.TaxId);
      if (index > -1) {
        tempObj.splice(index, 1);
      }
      return;
    });
    //console.log("tempObj ::::::::::::: ", tempObj);
    setSelectedAllFacilitiesOfSameTaxId(tempObj);
  };

  const onSelectedItemsHandler = (selectedFacilitiesList, unCheckedItem) => {
    const tempSelectedItems = [];
    //const properties = ['Address', 'FacilityID', 'FacilityName', 'FacilityOID', 'NationalProviderId', 'TaxId', 'isCkecked']
    if (selectedFacilitiesList && selectedFacilitiesList.length > 0) {
      const properties = Object.keys(selectedFacilitiesList[0]);
      console.log(
        'selectedFacilitiesList unCheckedItem :::::',
        selectedFacilitiesList,
        unCheckedItem,
      );
      if (selectedFacilities && selectedFacilities.length > 0) {
        console.log('IF CONDITION======', tempSelectedItems);
        const result = selectedFacilities
          .filter(
            (obj1) =>
              !selectedFacilitiesList.some(
                (obj2) => obj1.FacilityOID === obj2.FacilityOID,
              ),
          )
          .map((item) =>
            properties.reduce((newObj, FacilityName) => {
              newObj[FacilityName] = item[FacilityName];
              return newObj;
            }, {}),
          );
        console.log('selectedFacilitiesList result=====', result);
        tempSelectedItems.push(...result);
        tempSelectedItems.push(...selectedFacilitiesList);
      } else {
        console.log('else condition==========');
        //setSelectedFacilities([...selectedFacilities, ...selectedFacilitiesList]);
        tempSelectedItems.push(...selectedFacilities);
        tempSelectedItems.push(...selectedFacilitiesList);
      }
      console.log('tempSelectedItems ==========', tempSelectedItems);
      if (unCheckedItem && unCheckedItem.length > 0) {
        handleuncheckedItems(tempSelectedItems, unCheckedItem);
      } else {
        setSelectedFacilities(tempSelectedItems);
      }
      //setSelectedFacilities(tempSelectedItems);
    } else {
      if (unCheckedItem && unCheckedItem.length > 0) {
        handleuncheckedItems(tempSelectedItems, unCheckedItem);
      }
    }
  };

  const onFacilitySelected = (selectedFacilitiesList) => {
    setSelectedFacilities(selectedFacilitiesList);
  };

  const removeDuplicateObj = (selectedFacitliesArr) => {
    const uniqueFacilities = [];
    const filetredObj = selectedFacitliesArr.filter((element) => {
      const isDuplicate = uniqueFacilities.includes(element.FacilityOID);
      if (!isDuplicate) {
        uniqueFacilities.push(element.FacilityOID);

        return true;
      }

      return false;
    });
    return filetredObj;
  };

  const getFacilityListWithSameTaxId = async (taxId) => {
    try {
      let tempSelectedFacilities = [];
      if (taxId && taxId.length > 0) {
        FacilityListResponse = await axiosInstance.get(
          cacheBuster(
            APIEndpoints.getFacilityListResources() +
              '/taxid/' +
              taxId +
              '/pagesize/5000',
          ),
        );
        FacilityListDataResponse = FacilityListResponse.data;

        if (
          FacilityListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
        ) {
          console.log('FacilityListResponse', FacilityListResponse);
          console.log(
            'FacilityDetails getFacilityListWithSameTaxId',
            FacilityListDataResponse.Response.FacilityDetails,
          );
          //tempSelectedFacilities.push(...selectedFacilities);
          //tempSelectedFacilities.push(...FacilityListDataResponse.Response.FacilityDetails);

          const selectedFaciltiesLength = selectedFacilities.filter(
            (item) => item.TaxId === taxId,
          ).length;
          tempSelectedFacilities = removeDuplicateObj([
            ...selectedFacilities,
            ...FacilityListDataResponse.Response.FacilityDetails,
          ]);

          setSelectedFacilities(tempSelectedFacilities);
          setSelectedAllFacilitiesOfSameTaxId([
            ...selectedAllFacilitiesOfSameTaxId,
            taxId,
          ]);
          const facilitiesLength =
            FacilityListDataResponse.Response.FacilityDetails.length;
          const addedRecordsCount = facilitiesLength - selectedFaciltiesLength;

          toast.success(
            <ToastMessage
              type="info"
              subTitle={`${
                addedRecordsCount > 0 ? addedRecordsCount : 0
              } Facility(ies) got added with same Tax ID`}
            />,
          );
        }
      }
    } catch (error) {
      console.log('error', error);
      //setSelectedFacilities([])
      toast.error(
        <ToastMessage
          type="error"
          subTitle={
            'Error Occured while adding the facilities with same Tax ID'
          }
        />,
      );
    }
  };

  const onAddAllRecordsSameTaxId = (taxId) => {
    getFacilityListWithSameTaxId(taxId);
  };

  const onTrashButtonClickHandler = (FacilityOID, selectedDoctor, taxId) => {
    //e.stopPropagation();
    setDeleteItemId(FacilityOID);
    console.log(
      'onTrashButtonClickHandler selectedDoctor=======',
      selectedDoctor,
    );

    if (Object.prototype.hasOwnProperty.call(selectedDoctor, FacilityOID)) {
      console.log(
        'onTrashButtonClickHandler selectedDoctor=======',
        Object.prototype.hasOwnProperty.call(selectedDoctor, FacilityOID),
      );
      const tempObj = { ...selectedDoctor };
      delete tempObj[FacilityOID];
      setSelectedDoctor(tempObj);
    }

    const filterData =
      selectedFacilities &&
      selectedFacilities.filter((data) => {
        return data.FacilityOID !== FacilityOID;
      });
    setSelectedFacilities(filterData);
    setSelectedAllFacilitiesOfSameTaxId(
      selectedAllFacilitiesOfSameTaxId.filter((item) => item !== taxId),
    );
  };

  useEffect(() => {
    //onSelectedBrokersCount( selectedBroker.length );
    if (selectedFacilities) {
      updateSelectedItemCount(selectedFacilities.length);
      if (selectedFacilities.length === 0) {
        console.log('Reset/empty facilities ::::::::: ');
        //Added to reset/empty facilities selection - Start
        const tempObj = {
          facilities: [],
          selectedDoctorsByFacility: {},
        };
        const event = { target: { name: 'providerDetails', value: tempObj } };
        handleValChange(event);
        //Added to reset/empty facilities selection - End
      }
    }
    onSelectedItems(selectedFacilities);
    onFacilitySelected(selectedFacilities);
  }, [selectedFacilities]);

  useEffect(() => {
    if (selectedFacilitiesList && selectedFacilitiesList.length > 0) {
      setSelectedFacilities(selectedFacilitiesList);
    }
  }, [selectedFacilitiesList]);

  useEffect(() => {
    if (selectedItemsData && selectedItemsData.length > 0) {
      setSelectedFacilities(selectedItemsData);
    }
    if (
      selectedFacilityDoctors &&
      Object.keys(selectedFacilityDoctors).length > 0
    ) {
      setSelectedDoctor(selectedFacilityDoctors);
    }
  }, [selectedItemsData, selectedFacilityDoctors]);

  useEffect(() => {
    if (isContinueClicked) {
      const tempObj = {
        facilities: selectedFacilities,
        selectedDoctorsByFacility: selectedDoctor,
      };
      console.log('tempObj :::::::::::::: ', tempObj);
      const event = { target: { name: 'providerDetails', value: tempObj } };
      handleValChange(event);
      nextStep();
    }
  }, [isContinueClicked]);
  useEffect(() => {
    if (getSelectedDoctor !== null) {
      const tempObj = {
        facilities: selectedFacilities,
        selectedDoctorsByFacility: selectedDoctor,
      };
      console.log('tempObj :::::::::::::: ', tempObj);
      const event = { target: { name: 'providerDetails', value: tempObj } };
      //handleValChange(event);
      getSelectedDoctor(event);
    }
  }, [selectedDoctor]);

  return (
    <>
      <FacilityPanel
        label={label}
        deleteItemId={deleteItemId}
        //onSelectedBrokerHandler={() => {}}
        onSelectedItemsHandler={onSelectedItemsHandler}
        createUserFormData={createUserFormData}
        onSelectAllItems={onSelectAllItems}
        selectedItemsData={selectedItemsData}
        editAffiliatedRecords={editAffiliatedRecords}
        selectedFacilities={selectedFacilities}
      />
      <div className="mt-2">
        <FacilityViewPanel
          selectedFacilities={selectedFacilities}
          onTrashButtonClickHandler={onTrashButtonClickHandler}
          editAffiliatedRecords={editAffiliatedRecords}
          setSelectedDoctor={setSelectedDoctor}
          selectedDoctor={selectedDoctor}
          createUserFormData={createUserFormData}
          allowDoctorSelection={allowDoctorSelection}
          onAddAllRecordsSameTaxId={onAddAllRecordsSameTaxId}
          selectedAllFacilitiesOfSameTaxId={selectedAllFacilitiesOfSameTaxId}
        />
      </div>
      <div className="toastify">
        <ToastContainer
          position="top-center"
          className="toastcontainer"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
};

export default FacilityFilterPanel;
